export default __webpack_public_path__ + "static/media/raipay.d860e316.png";